import React from 'react';

const AboutSection = () => {
  return (
    <section className="about-section position-relative py-5 overflow-hidden bg-white">
      
      <div className="container py-5">
        
        {/* Main Header Text */}
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8 animate-slide-up">
            <h4 className="text-danger fw-bold small text-uppercase tracking-wider mb-2">About Us</h4>
            <h2 className="display-4 fw-bold text-dark" style={{ letterSpacing: '-1px', lineHeight: '1.2' }}>
              We want to bring wealth management and financial freedom together at Lotoswealth
            </h2>
          </div>
        </div>

        {/* Content Layout Grid */}
        <div className="row align-items-center position-relative g-4">
          
          {/* Left Large Image */}
          <div className="col-lg-4 col-md-5 mb-4 mb-md-0">
            <div className="position-relative shadow-sm rounded-4 overflow-hidden" style={{ height: '420px' }}>
              <img 
                src="/images/aboutus.jpg" 
                alt="Financial planning and wealth management strategy session" 
                className="w-100 h-100 object-fit-cover"
              />
            </div>
          </div>

          {/* Center Text Description */}
          <div className="col-lg-4 col-md-7 px-lg-4">
            <div className="mb-4 text-muted small" style={{ lineHeight: '1.8', fontSize: '0.95rem' }}>
              <p className="mb-3">
                We believe that we've managed to achieve what we set out to do. Today, we're proud to bring together people who share our passion for asset growth and strategic financial planning. This is how Lotoswealth began. We were a group of dedicated professionals united by a common vision: creating a comprehensive synergy across wealth management, investment planning, and asset management.
              </p>
              <p className="mb-4">
                We were tired of fragmented financial solutions. We felt strongly that portfolio management, tax planning, and strategic investments were more than just numbers: they were powerful tools to truly secure your future.
              </p>
            </div>
          </div>

          {/* Right Column with Stacked Images */}
          <div className="col-lg-4 col-md-12 d-flex flex-column gap-3 align-items-center align-items-lg-start mt-4 mt-lg-0">
            {/* Top Right Image */}
            <div className="shadow-sm rounded-4 overflow-hidden w-100" style={{ maxWidth: '280px', height: '200px' }}>
              <img 
                src="/images/portfolio-management-services.jpg" 
                alt="Investment planning consultation setup" 
                className="w-100 h-100 object-fit-cover"
              />
            </div>

            {/* Bottom Right Image */}
            <div className="shadow-sm rounded-4 overflow-hidden w-100 ms-lg-5" style={{ maxWidth: '200px', height: '140px' }}>
              <img 
                src="/images/wealth-management-services.jpg" 
                alt="Professional asset management strategist at work" 
                className="w-100 h-100 object-fit-cover"
              />
            </div>
          </div>

        </div>

      </div>

    </section>
  );
};

export default AboutSection;